import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaEnumerationFacet extends XmlSchemaFacet {}
